import thunk from 'redux-thunk';
import { applyMiddleware, combineReducers, compose, createStore as _createStore, StoreEnhancer } from 'redux';
import { IApplicationState, IReduxThunkContext, TReduxActions, TReduxStore } from '../../types/redux';
import { createSimpleReducer } from './createSimpleReducer';

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 * @param debugEnabled boolean - режим дебага
 */
export function createReduxStore(initialState: IApplicationState, context: IReduxThunkContext, debugEnabled: boolean) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    config: createSimpleReducer(initialState.config),
    projectData: createSimpleReducer(initialState.projectData),
    userData: createSimpleReducer(null),
    showCallbackButton: createSimpleReducer(true),
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(
    applyMiddleware(thunk.withExtraArgument(context)),
  ) as unknown as StoreEnhancer<IApplicationState>;

  const createStore = (): TReduxStore =>
    _createStore<IApplicationState, TReduxActions, IApplicationState, {}>(reducers, initialState, storeEnchancers);

  return createStore();
}
